<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Threads" class="d-icon d-icon--threads" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.14 22h-.005c-2.72-.02-4.81-1.004-6.214-2.924-1.249-1.71-1.894-4.088-1.916-7.068v-.014c.022-2.982.667-5.358 1.917-7.068C7.326 3.004 9.418 2.02 12.135 2h.011c2.084.016 3.828.604 5.182 1.748 1.274 1.076 2.17 2.608 2.665 4.556l-1.55.474c-.838-3.3-2.959-4.986-6.305-5.012-2.208.018-3.88.78-4.965 2.264-1.015 1.39-1.54 3.398-1.56 5.97.02 2.572.545 4.58 1.561 5.97 1.087 1.486 2.758 2.248 4.966 2.264 1.992-.016 3.31-.526 4.405-1.704 1.25-1.344 1.228-2.994.827-3.998-.235-.592-.663-1.084-1.24-1.458-.147 1.126-.473 2.038-.976 2.726-.672.918-1.625 1.42-2.832 1.492-.913.054-1.793-.182-2.474-.668-.808-.574-1.28-1.45-1.33-2.47-.05-.992.31-1.904 1.009-2.568.669-.634 1.609-1.006 2.72-1.076a9.596 9.596 0 0 1 2.293.118c-.095-.618-.284-1.11-.569-1.464-.39-.488-.993-.736-1.79-.742h-.023c-.641 0-1.512.194-2.066 1.1L8.76 8.54c.743-1.212 1.95-1.88 3.4-1.88h.033c2.426.016 3.87 1.646 4.015 4.49.082.038.164.078.244.118 1.131.584 1.959 1.468 2.394 2.558a5.715 5.715 0 0 1-1.175 5.966c-1.405 1.508-3.109 2.19-5.525 2.208h-.006Zm.762-9.742c-.184 0-.37.006-.561.018-1.394.086-2.264.788-2.214 1.786.05 1.046 1.102 1.532 2.114 1.472.929-.054 2.139-.452 2.343-3.092a7.29 7.29 0 0 0-1.682-.184Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconThreads',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
